import React, { FC } from 'react'
import { SecondaryButton } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

const StyledSecondaryButton = styled(SecondaryButton)<{
  first?: boolean
  last?: boolean
}>`
  ${({ first, last }) =>
    s({
      ml: first ? 6 : { xs: 3, md: 4 },
      mr: last ? { xs: 6, md: 4 } : { xs: 3, md: 4 },
      marginY: { xs: 6, lg: 8 },
      minHeight: 10,
      py: 4,
      px: 6,
      bgcolor: 'colorBackground01',
      color: 'colorInteractionIcon',
      border: 2,
      borderColor: 'colorInteractionIcon',
      height: '64px',
      flexDirection: 'column',
      whiteSpace: 'nowrap',
    })}

  &:not(:disabled) {
    &:hover,
    &:focus {
      ${s({
        bgcolor: 'colorBackground03',
        color: 'colorInteractionIcon',
        borderColor: 'colorInteractionIcon',
      })}
    }
  }
`

const getLines = (str: string) => {
  const lettersPerLine = str.length <= 16 ? 10 : 16
  let firstLineDone = false
  const firstLine = str
    .split(' ')
    .reduce((acc, word) => {
      const newLine = `${acc} ${word}`
      const currentLength = newLine.length
      if (currentLength <= lettersPerLine && !firstLineDone) {
        return newLine
      }

      firstLineDone = true
      return acc
    }, '')
    .trim()
  const secondLine = str.replace(firstLine, '').trim()
  return [firstLine, secondLine]
}

const formatTitle = (title: string) => {
  const [firstLine, secondLine] = getLines(title)
  return (
    <>
      <div>{firstLine}</div>
      <div>{secondLine}</div>
    </>
  )
}

type ButtonProps = {
  title: string
  linkHref: string
  isFirst: boolean
  isLast: boolean
}

export const Button: FC<ButtonProps> = ({
  title,
  linkHref,
  isFirst,
  isLast,
}) => (
  <StyledSecondaryButton first={isFirst} last={isLast} href={linkHref}>
    <div>{formatTitle(title)}</div>
  </StyledSecondaryButton>
)
